"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resendVerificationCode = exports.verifyClaim = exports.requestClaimAddition = void 0;

var _requester = require("./utils/requester");

var _enums = require("./enums");

var _builders = require("./builders");

var _schemas = require("./schemas");

var _helpers = require("./utils/helpers");

const requestClaimAddition = (0, _requester.requestHandler)(async (claim, requester = _requester.authenticatedRequester) => {
  const type = await (0, _helpers.getClaimType)(claim);
  const response = await requester().post(_enums.AUTH_ENDPOINT.requestClaimAddition, await (0, _builders.buildRequestClaimAdditionPayload)(type, claim));
  return _schemas.requestClaimAdditionSchema.validate(response.data);
});
exports.requestClaimAddition = requestClaimAddition;
const verifyClaim = (0, _requester.requestHandler)(async (code, verificationTicket, requester = _requester.authenticatedRequester) => {
  const response = await requester().post(_enums.AUTH_ENDPOINT.verifyClaim, (0, _builders.buildVerifyClaimPayload)(code, verificationTicket));
  return _schemas.verifyClaimSchema.validate(response.data);
});
exports.verifyClaim = verifyClaim;
const resendVerificationCode = (0, _requester.requestHandler)(async (verificationTicket, requester = _requester.authRequester) => {
  const response = await requester().post(_enums.AUTH_ENDPOINT.resendVerificationCode, (0, _builders.buildResendVerificationCode)(verificationTicket));
  return _schemas.resendVerificationCodeSchema.validate(response.data);
});
exports.resendVerificationCode = resendVerificationCode;